import {Link} from 'react-router-dom'
import {toast} from 'react-toastify'
import {Pagination} from 'antd'
import {KTSVG, toAbsoluteUrl} from '../../../../_khaugali/helpers'
import {IExpenseMasterModel} from '../../../models/expense/ExpenseMasterModel'
import {getAllExpense} from '../../../modules/expense_page/ExpenseMasterCRUD'
import {useEffect, useState} from 'react'
type Props = {}

interface IClient {
  loading: boolean
  expenseMasterData: IExpenseMasterModel[]
  temExpenseMasterData: IExpenseMasterModel[]
  SearchText: string
}

const ExpenseMasterList: React.FC<Props> = () => {
  const [state, setState] = useState<IClient>({
    loading: false,
    expenseMasterData: [] as IExpenseMasterModel[],
    temExpenseMasterData: [] as IExpenseMasterModel[],
    SearchText: '',
  })

  useEffect(() => {
    setState({...state, loading: true})
    setTimeout(() => {
      getAllExpenseData()
    }, 100)
  }, [])

  function getAllExpenseData() {
    getAllExpense()
      .then((resp) => {
        const resExpData = resp.data.responseObject
        setState({
          ...state,
          expenseMasterData: resExpData,
          temExpenseMasterData: resExpData,
          loading: false,
        })
        setTotal(resExpData.length)
      })
      .catch((error) => {
        toast.error(`${error}`, {position: 'top-center'})
        setState({...state, expenseMasterData: [], temExpenseMasterData: [], loading: false})
      })
  }
  // ============*****---------------- Pagination ----------------*****=============

  const [total, setTotal] = useState(0) //  length
  const [page, setPage] = useState(1)
  const [postPerPage, setPostPerPage] = useState(10)

  const indexOfLastPage = page * postPerPage
  const indexOfFirstPage = indexOfLastPage - postPerPage
  const currentPosts: IExpenseMasterModel[] = state.expenseMasterData.slice(
    indexOfFirstPage,
    indexOfLastPage
  )
  const onShowSizeChange = (current: any, pageSize: any) => {
    setPostPerPage(pageSize)
  }

  //------------------- the value of the search field----------------
  const [name, setName] = useState('')

  //------------------- the search result-----------------
  const filter = (e: any) => {
    const keyword = e.target.value

    if (keyword !== '') {
      const results = state.temExpenseMasterData.filter((user) => {
        user.expenseName.toLowerCase().startsWith(keyword.toLowerCase()) ||
          user.bTransTypeName.toLowerCase().startsWith(keyword.toLowerCase()) ||
          user.expenseTitle.toLowerCase().startsWith(keyword.toLowerCase())
        // Use the toLowerCase() method to make it case-insensitive
      })
      setState({...state, expenseMasterData: results})
      setTotal(results.length)
    } else {
      setState({...state, expenseMasterData: state.temExpenseMasterData})
      // If the text field is empty, show all users
      setTotal(state.temExpenseMasterData.length)
    }
    setName(keyword)
  }

  return (
    <>
      <div className={`card `}>
        {/* begin::Header */}
        <div className='card-header border-0 py-2' style={{backgroundColor: '#2a3952'}}>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-3 mb-1 text-light'>Products List</span>
            <span className='text-muted mt-1 fw-bold fs-7'>Total 0 Products</span>
          </h3>

          <div className='card-header border-0 pt-4' id='kt_chat_contacts_header'>
            <form className='w-100 position-relative' autoComplete='off'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute pt-14 ms-5 translate-middle-y'
              />
              <input
                type='text'
                className='form-control form-control-solid px-15'
                name='search'
                placeholder='Search'
                onChange={filter}
                value={name}
              />
            </form>
          </div>

          <div
            className='card-toolbar'
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            data-bs-trigger='hover'
            title='Click to add a user'
          >
            <Link to='/expense/create' className='btn btn-sm btn-light-primary'>
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
              Add New
            </Link>
          </div>
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        <div className='card-body py-3'>
          {/* begin::Table container */}
          <div className='table-responsive'>
            {/* begin::Table */}
            <table className='table table-row-bordered table-row-gray-300 align-middle gs-0 gy-4'>
              {/* begin::Table head */}
              <thead>
                <tr className='fw-bolder fs-5'>
                  <th className='min-w-50px'>Transactopm Type</th>
                  <th className='min-w-50px'>Expense Type</th>
                  <th className='min-w-50px'>Title</th>
                  <th className='min-w-50px'>Description</th>
                  <th className='min-w-50px'>Mode</th>
                  <th className='min-w-50px'>Amount</th>
                  <th className='min-w-50px'>Date</th>
                </tr>
              </thead>
              <tbody>
                {/* =================== Api Data Blank ============== */}
                <tr className={state.loading === true ? '' : 'd-none'}>
                  <td colSpan={9}>
                    <div className='d-flex justify-content-center mt-5 pt-5'>
                      <div
                        className='spinner-border'
                        style={{width: '3rem', height: '3rem'}}
                        role='status'
                      >
                        <span className='visually-hidden'>Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
                {currentPosts.length > 0 &&
                  currentPosts.map((data, index) => {
                    console.log(data)
                    return (
                      <tr className='text-dark'>
                        <td>
                          <span className='d-flex align-items-center text-hover-primary fs-6'>
                            {data.bTransTypeName}
                          </span>
                        </td>
                        <td>
                          <span className='text-hover-primary d-block fs-6'>
                            {data.expenseName}
                          </span>
                        </td>
                        <td>
                          <a href='#' className='text-dark text-hover-primary d-block mb-1 fs-6'>
                            {data.expenseTitle}
                          </a>
                        </td>
                        <td>
                          <a href='#' className='text-dark text-hover-primary d-block mb-1 fs-6'>
                            {data.descriptions}
                          </a>
                        </td>
                        <td>
                          <a href='#' className='text-dark text-hover-primary d-block mb-1 fs-6'>
                            {data.transactionMode}
                          </a>
                        </td>
                        <td>
                          <a href='#' className='text-dark text-hover-primary d-block mb-1 fs-6'>
                            {data.amount}
                          </a>
                        </td>
                        <td>
                          <a href='#' className='text-dark text-hover-primary d-block mb-1 fs-6'>
                            {data.transactionDate}
                          </a>
                        </td>
                      </tr>
                    )
                  })}
                {/* =================== Loading get Api Data ============== */}
                <tr
                  className={currentPosts.length === 0 && state.loading === false ? '' : 'd-none'}
                >
                  <td colSpan={9}>
                    <div className='d-flex justify-content-center mt-3 pt-3 fs-5'>
                      No data found
                    </div>
                    <div className='d-flex justify-content-center mt-2 pt-2'>
                      <img
                        className='w-25'
                        src={toAbsoluteUrl('/media/illustrations/sigma-1/13-dark.png')}
                        alt=''
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className='text-center'>
            <Pagination
              onChange={(value: any) => setPage(value)}
              pageSize={postPerPage}
              total={total}
              current={page}
              showSizeChanger
              showQuickJumper
              onShowSizeChange={onShowSizeChange}
              showTotal={(total) => `Total ${total} items`}
            ></Pagination>
          </div>
        </div>
      </div>
    </>
  )
}

export default ExpenseMasterList
